<div class="flex-row">
  <sag-ui-input class="flex-1" [required]="required" [disabled]="true" [value]="value?.displayName" [label]="placeholder | translate" />

  @if (!readonly) {
    @if (!value) {
      <sag-ui-button [square]="true" (click)="openEmployeeSelection()">
        <fa-icon icon="user-plus" />
      </sag-ui-button>
    } @else {
      <sag-ui-button [icon]="'delete'" [square]="true" (click)="removeSelected()" />
    }
  }
</div>
